import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function LocationSection() {
  const {
    t
  } = useLanguage();
  return <section id="lokalita" className="relative py-32 min-h-screen flex items-center" data-id="element-118">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-fixed grayscale" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/p895FZ1ENpM2QyZUh39PBp/ResidenceMalostranska-7112.jpg")'
    }} data-id="element-119" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-charcoal-900/80 backdrop-blur-[2px]" data-id="element-120" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full" data-id="element-121">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-122">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-5" data-id="element-123">
            <div className="w-12 h-[1px] bg-gold mb-6" data-id="element-124"></div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading text-cream mb-6 leading-tight" data-id="element-125">
              {t.location.heading1} <br data-id="element-126" />
              <span className="italic text-gold" data-id="element-127">{t.location.heading2}</span>
            </h2>
            <p className="text-lg md:text-xl text-cream/80 font-light leading-relaxed mb-8" data-id="element-128">
              {t.location.desc}
            </p>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:mt-24" data-id="element-129">
            {t.location.cards.map((card, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2 + index * 0.2
          }} className={`p-8 bg-charcoal-900/40 backdrop-blur-md border border-cream/10 hover:border-gold/50 transition-colors duration-500 ${index === 2 ? 'sm:col-span-2 sm:w-1/2 sm:justify-self-center' : ''}`} data-id="element-130">
                <h3 className="text-2xl font-heading text-gold mb-3" data-id="element-131">
                  {card.title}
                </h3>
                <p className="text-cream/80 font-light leading-relaxed" data-id="element-132">
                  {card.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}